module.exports = __webpack_public_path__ + "img/工业物联网平台1.92598947.png";